"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconShoppingBag2 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconShoppingBag2 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09848 5.00942C7.55811 2.72249 9.57808 1 12.0004 1C14.4227 1 16.4426 2.72249 16.9023 5.00942C17.1246 5.01516 17.3302 5.02441 17.5201 5.03929C18.0427 5.08026 18.5239 5.16814 18.9838 5.38646C19.7008 5.72681 20.3003 6.27278 20.7061 6.95489C20.9664 7.39242 21.0988 7.86331 21.1884 8.37979C21.2744 8.8754 21.3314 9.48449 21.4004 10.2197L22.0081 16.7019C22.0899 17.575 22.1572 18.2926 22.1625 18.8779C22.168 19.4835 22.1105 20.0451 21.8811 20.579C21.5274 21.4022 20.9077 22.0828 20.1212 22.5117C19.611 22.7899 19.0572 22.8996 18.4537 22.9507C17.8705 23 17.1497 23 16.2728 23H7.72799C6.85109 23 6.13024 23 5.547 22.9507C4.94359 22.8996 4.38977 22.7899 3.8796 22.5117C3.09306 22.0828 2.4733 21.4022 2.11964 20.579C1.89024 20.0451 1.83277 19.4835 1.83824 18.8779C1.84353 18.2926 1.91082 17.575 1.99269 16.7019L2.60039 10.2197C2.66931 9.48449 2.7264 8.8754 2.81234 8.37979C2.90191 7.86331 3.03433 7.39242 3.29462 6.95488C3.70042 6.27278 4.29996 5.72681 5.01696 5.38646C5.47688 5.16814 5.95808 5.08026 6.48067 5.03929C6.6705 5.02441 6.87614 5.01516 7.09848 5.00942ZM9.17107 5C9.58291 3.83481 10.6941 3 12.0004 3C13.3066 3 14.4178 3.83481 14.8297 5L9.17107 5Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.0004 9V6C16.0004 3.79086 14.2095 2 12.0004 2C9.79123 2 8.00037 3.79086 8.00037 6V9M3.59237 10.352L2.99237 16.752C2.82178 18.5717 2.73648 19.4815 3.03842 20.1843C3.30367 20.8016 3.76849 21.3121 4.35839 21.6338C5.0299 22 5.94374 22 7.77142 22H16.2293C18.057 22 18.9708 22 19.6423 21.6338C20.2322 21.3121 20.6971 20.8016 20.9623 20.1843C21.2643 19.4815 21.179 18.5717 21.0084 16.752L20.4084 10.352C20.2643 8.81535 20.1923 8.04704 19.8467 7.46616C19.5424 6.95458 19.0927 6.54511 18.555 6.28984C17.9444 6 17.1727 6 15.6293 6L8.37142 6C6.82806 6 6.05638 6 5.44579 6.28984C4.90803 6.54511 4.45838 6.95458 4.15403 7.46616C3.80846 8.04704 3.73643 8.81534 3.59237 10.352Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconShoppingBag2 = IconShoppingBag2;
//# sourceMappingURL=IconShoppingBag2.js.map